<template>
    <div @click="state.isOpen = true" class="cursor-pointer" v-bind="$attrs">
        <slot></slot>
    </div>
    <ModalCustom :is-open="state.isOpen" @close="onClose" title="Group Members">
        <div class="my-4 flex gap-1 items-center">
            <MemberMultiselectInput
                :current-users="state.members"
                @select="addMember"
                @remove="removeMember"
            ></MemberMultiselectInput>
        </div>

        <h3 class="mb-2">Members</h3>
        <div class="flex gap-4" v-if="state.members.length > 0">
            <div
                v-for="member in state.members"
                :key="member.id"
                class="
                    text-sm
                    p-2
                    rounded
                    inline-flex
                    bg-gray-100
                    gap-2
                    items-center
                "
            >
                <img
                    :src="member.avatar"
                    :alt="member.name"
                    v-if="member.avatar"
                    class="w-8 h-8 rounded-full aspect-square"
                />
                {{ member.name ?? member.email }}
                <button
                    type="button"
                    class="
                        bg-transparent
                        text-gray-500
                        flex
                        items-center
                        hover:text-gray-700 hover:bg-gray-300
                        p-1
                        rounded-lg
                    "
                    @click="removeMember(member)"
                >
                    <ion-icon name="close-outline"></ion-icon>
                </button>
            </div>
        </div>
    </ModalCustom>
</template>

<script setup>
import { defineProps, reactive, onMounted } from "vue";
import emitter from "tiny-emitter/instance";

const state = reactive({
    isOpen: false,
    members: [],
    selectedUsers: [],
    groupId: null,
});

function onClose() {
    state.isOpen = false;
}

async function addMember(user) {
    state.members.push({
        id: user.id,
        user_id: user.id,
        name: user.name,
        email: user.email,
        avatar: user.avatar,
        user,
    });
    await axios.post(`/chat/group/${state.groupId}/addMember`, {
        user_id: user.id,
    });
}

async function removeMember(member) {
    console.log({ member });
    state.members = state.members.filter((m) => m.id !== member.id);
    await axios.post(`/chat/group/${state.groupId}/removeMember`, {
        user_id: member.id,
    });
}

emitter.on("open-group-members", (groupId) => {
    state.isOpen = true;
    getMembers(groupId);
});

async function getMembers(groupId) {
    state.groupId = groupId;
    const resp = await axios.get(`/chat/group/${state.groupId}/members`);
    state.members = resp.data?.map((member) => {
        return {
            id: member.id,
            user_id: member.id,
            name: member.name,
            email: member.email,
            avatar: member.avatar,
            user: member.user,
        };
    });
}

onMounted(() => {
    window.addEventListener("message", function (event) {
        const action = event.data.action;
        if (action === "open_group_members") {
            getMembers(event.data.groupId);
            state.isOpen = true;
        }
    });
});
</script>
